/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuperGroupRequest
 */
export interface SuperGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof SuperGroupRequest
     */
    name: string;
}

export function SuperGroupRequestFromJSON(json: any): SuperGroupRequest {
    return SuperGroupRequestFromJSONTyped(json, false);
}

export function SuperGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuperGroupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function SuperGroupRequestToJSON(value?: SuperGroupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

